import useTranslation from '../../hooks/useTranslation';
import FieldRow from '../FieldRow';

import { VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const WeatherSection: FunctionComponent<Props> = ({ testId = TEST_ID, weather }) => {
    const translations = useTranslation();

    return (
        <VerticalContainer className={styles.weatherSection} testId={testId}>
            <Wrapper className={styles.sectionHeader}>
                {translations.WEATHER_AT_APPLICATION}
            </Wrapper>

            {weather === null ? (
                <Wrapper className={styles.unavailable}>{translations.WEATHER_UNAVAILABLE}</Wrapper>
            ) : (
                <VerticalContainer>
                    <FieldRow label={translations.WIND_SPEED} value={`${weather.windSpeedMph}`} />

                    <FieldRow label={translations.GUST_SPEED} value={`${weather.gustMph}`} />

                    <FieldRow label={translations.WIND_DIRECTION} value={weather.windDirection} />

                    <FieldRow label={translations.TEMPERATURE} value={`${weather.temperatureF}`} />

                    <FieldRow label={translations.HUMIDITY} value={`${weather.humidityPct}`} />
                </VerticalContainer>
            )}
        </VerticalContainer>
    );
};

export default WeatherSection;
